/** Minimum length for the password field (matches the server constraint). */
export const PASSWORD_MIN_LENGTH = 12;

/** Maximum length for the password field (matches the server constraint). */
export const PASSWORD_MAX_LENGTH = 50;

/** Maximum length for the email field (matches the server constraint). */
export const EMAIL_MAX_LENGTH = 255;

/** Maximum length for a person's full name (matches the server constraint). */
export const FULL_NAME_MAX_LENGTH = 150;

/**
 * A person's full name, as the user settings API accepts it: letters, combining marks, digits, spaces and
 * `. , - ' [ ]`, with at least one letter or digit so a name of only spaces or dots is rejected.
 */
export const FULL_NAME_PATTERN = /^(?=.*[\p{L}\d])[\p{L}\p{M}\s\d.,'[\]-]+$/u;

/** Maximum length for a phone number (matches the server constraint). */
export const PHONE_NUMBER_MAX_LENGTH = 20;

/** A location's phone number in Add Location: digits, spaces and `+ ( ) . -`. */
export const PHONE_NUMBER_PATTERN = /^[0-9\s+().-]+$/;

/** A contact phone number, as the user and company settings APIs accept it: digits, spaces and `, - . ( ) +`. */
export const CONTACT_PHONE_NUMBER_PATTERN = /^[\d ,.()+-]+$/;
